import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { useState } from 'react'
import { CompanySummary, companiesQueryOptions } from '@/entities/company'
import { CreateCompanyDialog } from '@/features/manage-company'
import { Button } from '@/shared/ui/button'
import { Checkbox } from '@/shared/ui/checkbox'
import { EmptyState } from '@/shared/ui/empty-state'
import { PageHeader } from '@/shared/ui/page-header'

export const Route = createFileRoute('/_app/companies/')({
  component: CompaniesPage,
})

const SKELETON_ROWS = ['s1', 's2', 's3']

function ListSkeleton() {
  return (
    <div className="flex flex-col gap-2" aria-hidden>
      {SKELETON_ROWS.map((s) => (
        <div key={s} className="h-16 animate-pulse rounded-card bg-bg-elevated" />
      ))}
    </div>
  )
}

function CompaniesPage() {
  const [showArchived, setShowArchived] = useState(false)
  const [createOpen, setCreateOpen] = useState(false)

  const companies = useQuery(companiesQueryOptions({ archived: showArchived }))
  const items = companies.data ?? []

  return (
    <>
      <PageHeader
        title="Компании"
        actions={<Button onClick={() => setCreateOpen(true)}>Новая компания</Button>}
      />

      <div className="mb-4 flex flex-wrap items-center gap-2">
        <Checkbox
          className="rounded-pill bg-bg-surface px-3.5 py-2 hover:bg-bg-raised"
          checked={showArchived}
          onChange={(e) => setShowArchived(e.target.checked)}
          label="Показать архив"
        />
      </div>

      {companies.isPending ? (
        <ListSkeleton />
      ) : items.length === 0 ? (
        <EmptyState
          title="Компаний нет"
          description="Заведите первую компанию — она станет доступна всем сервисам экосистемы."
          action={<Button onClick={() => setCreateOpen(true)}>Новая компания</Button>}
        />
      ) : (
        <ul className="flex flex-col gap-2">
          {items.map((company) => (
            <li key={company.id}>
              <Link to="/companies/$companyId" params={{ companyId: company.id }}>
                <CompanySummary company={company} />
              </Link>
            </li>
          ))}
        </ul>
      )}

      <CreateCompanyDialog open={createOpen} onClose={() => setCreateOpen(false)} />
    </>
  )
}
